/* @flow */

import * as React from 'react';

type Props = {
  children: any,
  value: any,
  callback: (value: any, prevValue: any) => void,
};

class OnValueChange extends React.Component<Props, State> {
  props: Props;

  componentDidUpdate(prevProps: Props) {
    const { callback, value } = this.props;
    if (value !== prevProps.value) {
      callback(value, prevProps.value);
    }
  }

  render() {
    const { children } = this.props;
    return children;
  }
}

export default OnValueChange;
